export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9763.717e54ff.jpg";